export let QualificationLayoutJSON = [
    {
        name: "Details",
        child: [
            {
                child: [
                    {
                        child: [
                            {
                                child: [
                                    {
                                        parentid: "1004-col-1",
                                        elementid: "1001",
                                        elementtype: "customSelect",
                                    },
                                ],
                                colpos: 1,
                                parentid: "1004-columns",
                                elementid: "1004-col-1",
                                elementtype: "column",
                                colsizeclass: "col-md-6",
                            },
                            {
                                child: [
                                    {
                                        parentid: "1004-col-2",
                                        elementid: "1002",
                                        elementtype: "textfield",
                                    },
                                ],
                                colpos: 2,
                                parentid: "1004-columns",
                                elementid: "1004-col-2",
                                elementtype: "column",
                                colsizeclass: "col-md-6",
                            },
                        ],
                        colsize: 2,
                        parentid: "qual-fieldset-body",
                        elementid: "1004",
                        elementtype: "columns",
                    },
                    {
                        child: [
                            {
                                child: [
                                    {
                                        parentid: "1005-col-1",
                                        elementid: "1003",
                                        elementtype: "multiselect",
                                    },
                                ],
                                colpos: 1,
                                parentid: "1005-columns",
                                elementid: "1005-col-1",
                                elementtype: "column",
                                colsizeclass: "col-md-6",
                            },
                            {
                                child: [],
                                colpos: 2,
                                parentid: "1005-columns",
                                elementid: "1005-col-2",
                                elementtype: "column",
                                colsizeclass: "col-md-6",
                            },
                        ],
                        colsize: 2,
                        parentid: "qual-fieldset-body",
                        elementid: "1005",
                        elementtype: "columns",
                    },
                ],
                parentid: "qual-section-form",
                elementid: "qual-fieldset",
                elementtype: "fieldset",
            },
        ],
        parentid: "myTabContent",
        elementid: "qual-section",
        description: "",
        elementtype: "section",
        "section-type": "form",
        linkedentitytype: -1,
    },
];